import { v4 as uuidv4 } from 'uuid';

import { createOkvedSelectOption } from 'CorePackage/RegistryModule/common/createOkvedSelectOption';
import { createCountrySelectOption } from 'CorePackage/CatalogsModule/common/createCountriesSelectOption';
import { IKnmSubject248 } from 'APIPackage/KnmModule/interfaces/IKnmSubject248';
import { IKnmFormSubject } from 'KnmPackage/KnmSubjectModule/interfaces/IKnmFormSubject';

export const convertSubjectDataToFormValues = (
  subject?: IKnmSubject248 | null,
  isKnmErknm?: boolean,
): IKnmFormSubject => ({
  subjectTypePm:
    subject?.subjectType && !isKnmErknm
      ? {
          ...subject.subjectType,
          id: subject.subjectType.title,
          label: subject.subjectType.title,
        }
      : undefined,
  subjectTypeKnm:
    subject?.subjectType && isKnmErknm
      ? {
          ...subject.subjectType,
          id: subject.subjectType.title,
          label: subject.subjectType.title,
        }
      : undefined,
  isFiz: typeof subject?.isFiz === 'boolean' ? subject?.isFiz : undefined,
  inn: subject?.inn || undefined,
  ogrn: subject?.ogrn || undefined,
  checkSubjectResult: subject?.checkSubjectResult || null,
  okveds: subject?.okveds?.map(okved => ({
    okved: createOkvedSelectOption(okved),
    listId: okved.numGuid || uuidv4(),
  })),
  organizationName: subject?.organizationName || undefined,
  organizationGuid: subject?.guid || uuidv4(),
  organizationAutocomplete: typeof subject?.isAutocomplete === 'boolean' ? subject?.isAutocomplete : undefined,
  mspCode: subject?.mspCode || undefined,
  country: subject?.country ? createCountrySelectOption(subject.country) : undefined,
  kpp: subject?.kpp || undefined,
  rafpNza: subject?.rafpNza || undefined,
  locationAddress: subject?.locationAddress || undefined,
  workAddress: subject?.workAddress || undefined,
  factualAddress: subject?.factualAddress || undefined,
  locationregion: undefined,
  locationnotInFIAS: subject?.locationNotInFIAS || undefined,
  locationmanualAddress: subject?.locationManualAddress || undefined,
  snils: subject?.snils || undefined,
  ervkId: subject?.ervkId || undefined,
  document: subject?.document || undefined,
  smevRequestStatus: subject?.smevRequestStatus || undefined,
  isSonko: typeof subject?.isSonko === 'boolean' ? subject.isSonko : undefined,
  nkoForeignAgentsRegistryNumber: subject?.nkoForeignAgentsRegistryNumber || undefined,
  nkoForeignAgentsRegistryInclusionDate: subject?.nkoForeignAgentsRegistryInclusionDate || undefined,
  nkoForeignAgentsRegistryExclusionDate: subject?.nkoForeignAgentsRegistryExclusionDate || undefined,
  isNko: !!subject?.nkoForeignAgentsRegistryInclusionDate,
  isOrganizationNew: subject?.subjectType ? false : undefined,
  dateCreate: subject?.dateCreate || undefined,
  firstOrganizationName: subject?.firstOrganizationName || undefined,
  isPresentInItRegistry:
    typeof subject?.isPresentInItRegistry === 'boolean' ? subject?.isPresentInItRegistry : undefined,
  itAccreditationResponse: subject?.itAccreditationResponse || undefined,
  smevItAccreditationRequestStatus: subject?.smevItAccreditationRequestStatus || undefined,
  inspectionResults: subject?.inspectionResults,
  isFilledFromLink: subject?.isFilledFromLink || undefined,
  locationRegionCodeFromFns: subject?.locationRegionCodeFromFns || undefined,
  isAutocomplete: subject?.isAutocomplete ?? undefined,
});
